<template>
  <v-app>
    <v-container class="fill-height">
      <v-row
        justify="center"
        align="center"
      >
        <v-col
          cols="12"
          sm="8"
          md="6"
          lg="4"
          class="text-center"
        >
          <AuthErrorCard
            v-if="error"
            :error="error"
            @return="handleReturn"
          />

          <div
            v-else
            class="d-flex flex-column align-center"
          >
            <v-img
              :src="brand.logo"
              width="180"
              class="mb-8"
            />

            <v-progress-circular
              indeterminate
              color="primary"
              size="32"
              class="mb-4"
            />

            <h2 class="text-h6 font-weight-medium text-medium-emphasis">
              Completing Authentication
            </h2>
            <p class="text-body-2 text-medium-emphasis mt-2">
              Please wait while we verify your credentials
            </p>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import { SystemError } from '@/models/error'
import AuthErrorCard from '@/components/auth/AuthErrorCard.vue'
import { brand } from '@/config/brand'

const router = useRouter()
const route = useRoute()
const authStore = useAuthStore()
const error = ref<string | null>(null)

onMounted(async () => {
  if (route.query.error) {
    error.value = (route.query.error_description as string) || 'Authentication failed'
    return
  }

  try {
    await authStore.handleMicrosoftCallback(
      route.query.code as string,
      route.query.state as string
    )
    router.push((route.query.redirect as string) || '/')
  } catch (e) {
    if (e instanceof SystemError && e.statusCode === 403) {
      error.value = 'This account is not authorized. Peraso employees must use their @perasoinc.com Microsoft account.'
    } else {
      error.value = e instanceof Error ? e.message : 'Authentication failed'
    }
  }
})

const handleReturn = async () => {
  await authStore.logout()
}
</script>
